export type DropdownLinkData = {
  accessElementID: number;
  displayName: string;
  url: string;
};

export type MenuLink = { label: string; to: string };

// The subscriptions access element grants the renewal API endpoints but has no page of its own;
// subscriptions are shown on Manage School.
const NO_PAGE_ENTRIES = ['subscriptions'];

const hasNoPage = (link: DropdownLinkData) =>
  [link.url, link.displayName].some((value) =>
    NO_PAGE_ENTRIES.includes(
      (value ?? '').toLowerCase().replace(/^\/+/, '')
    )
  );

export const menuLinks = (
  links: DropdownLinkData[] | null | undefined
): MenuLink[] =>
  (links ?? [])
    .filter((link) => link.displayName !== 'Sign out' && !hasNoPage(link))
    .map((link) => ({
      label: link.displayName,
      to: '/' + link.displayName.toLowerCase().replaceAll(' ', '-'),
    }));
